import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Events from "@/pages/Events";
import EventDetails from "@/pages/EventDetails";
import Cart from "@/pages/Cart";
import Profile from "@/pages/Profile";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Tickets from "@/pages/Tickets";
import Navbar from "@/Components/Navbar";
import Footer from "@/Components/Footer";
import PasswordRescue from "../pages/PasswordRescue";
import ChangePassword from "../pages/ChangePassword";
import Pending from "../pages/Pending";
import Failure from "../pages/Failure";
import PaymentApproved from "../pages/PaymentApproved";
import ScrollToTop from "../Components/ScrollToTop";
import ProducersPage from "../pages/ProducersPage";
import ProducerProfile from "../pages/ProducerProfile";
import NotFound from "../pages/NotFound";
import Home from "../pages/Home";

const AppRoutes = () => {
    return (
        <Router>
            <Navbar/>
            <ScrollToTop/>
            <Routes>
                <Route path="/" element={<Events />} />
                <Route path="/about" element={<Home/>} />
                <Route path="/eventos/:slug" element={<EventDetails />} />
                <Route path="/tickets" element={<Tickets />} />
                <Route path="/carrito" element={<Cart />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/rescue-pass" element={<PasswordRescue />} />
                <Route path="/change_password" element={<ChangePassword />} />
                <Route path="/pending" element={<Pending />} />
                <Route path="/failure" element={<Failure />} />
                <Route path="/payment-approved" element={<PaymentApproved />} />
                <Route path="/producers" element={<ProducersPage />} />
                <Route path="/producers/:producerSlug" element={<ProducerProfile />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer/>
        </Router>
    );
};

export default AppRoutes;
